module.exports = __webpack_public_path__ + "img/default-avatar.ba8a22a6.jpg";